// Lecteur de PDF : avant chaque carte Fichier pointant vers un PDF, un bouton « Lire le document en ligne »
// ouvre le document dans un cadre nommé, avec lien « Ouvrir dans un nouvel onglet » et bouton de fermeture.
// Rien n'est chargé avant le clic ; sur écran étroit (téléphone), pas de bouton : le téléchargement suffit.
export default function lecteurPdf() {
    if (!matchMedia("(min-width: 900px)").matches) return;
    document.querySelectorAll(".kg-file-card").forEach((carte, n) => {
        const a = carte.querySelector("a.kg-file-card-container[href]");
        if (!a || !/\.pdf(\?|#|$)/i.test(a.getAttribute("href"))) return;
        const titre = (carte.querySelector(".kg-file-card-title")?.textContent || "Document").trim();
        const bloc = document.createElement("div");
        bloc.className = "pdf-lecteur";
        const id = `pdf-cadre-${n + 1}`;
        bloc.innerHTML = `<button type="button" class="btn btn-primaire" aria-expanded="false" aria-controls="${id}">Lire le document en ligne</button>
<div id="${id}" class="pdf-cadre" hidden><p><a href="${a.href}" target="_blank" rel="noopener">Ouvrir dans un nouvel onglet</a></p></div>`;
        carte.before(bloc);
        const bouton = bloc.querySelector("button"), cadre = bloc.querySelector(".pdf-cadre");
        bouton.addEventListener("click", () => {
            const ouvert = cadre.hidden;
            if (ouvert && !cadre.querySelector("iframe")) {
                const f = document.createElement("iframe");
                f.src = a.href; f.title = `Document : ${titre}`; f.loading = "lazy";
                cadre.prepend(f);
            }
            cadre.hidden = !ouvert;
            bouton.setAttribute("aria-expanded", String(ouvert));
            bouton.textContent = ouvert ? "Refermer le document" : "Lire le document en ligne";
            if (ouvert) cadre.querySelector("a").focus();
        });
    });
}
